export default __webpack_public_path__ + "static/media/notification_error.1aba6e7f.svg";